import { render, staticRenderFns } from "./GestionPlantExterna.vue?vue&type=template&id=549eb72d"
import script from "./GestionPlantExterna.vue?vue&type=script&lang=js"
export * from "./GestionPlantExterna.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports